<template>
  <div class="accessories">
    <div class="inner_accessories">
        <div class="container">
            <b-row>
                <b-col sm="12" lg="6">
                    <h2 class="mainHeader">
                        SimPedals
                    </h2>
                    <h2 class="subHeader">
                        Unlock your full potential
                    </h2>
                    <p class="mainText" v-html="acf.acf.main_text_top"></p>
                    <b-row class="linksBelow">
                        <b-col lg="6" sm="12">
                            <b-link href="https://www.imsim.eu.com/talentosimpedals" target="_blank">
                                <button class="accessBTN">
                                    Visit Pedal Web Shop
                                </button>
                            </b-link>
                        </b-col>
                        <b-col lg="6" sm="12">
                            <b-link href="https://www.youtube.com/watch?v=xkCLr4XNczc&t=1s" target="_blank">
                                <button class="accessBTN">
                                    See SimPedal Channel
                                    <img class="youtube" src="https://wp-ocssport.ocs-sport.com/imsim-uk/wp-content/uploads/sites/8/2025/02/YouTube_Icon.png">
                                </button>
                            </b-link>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </div>
    </div>
    <div class="contactArea">
        <div class="container">
            <b-row>
                <b-col>
                    <h2 class="contactTitle"> Contact us to get a personalised solution</h2>
                    <p class="contactText">
                        Our friendly team of experts are on hand to help pick<br>
                        the perfect products to suit your needs, <br>
                        available space and budget.
                    </p>
                </b-col>
                <b-col>
                    <Form/>
                </b-col>
            </b-row>
        </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Form from '@/components/AccessoriesForm.vue'
export default {
  name: 'Accessories',
  components: {
    Form
  },
  data: function() {
    return {
      acf: [],
      simData: []
    };
  },
  methods: {
    isMobile() {
        if( screen.width <= 500 ) {
            return true;
        }
        else {
            return false;
        }
    },
  },
  mounted() {
    axios //add API Call
        .get(
            process.env.VUE_APP_API_URL + 'imsim-uk' + "/wp-json/wp/v2/pages/69" + '?randomadd=' +
          new Date().getTime()
        ) // Page number changed on each page based on JSON page id you are calling
        .then((response) => (
            this.acf = response.data,
            this.simData = response.data.acf.sims
        )); //API data wanted pulled out
  },
}
</script>

<style scoped>
.inner_accessories {
    background-image: url(https://wp-ocssport.ocs-sport.com/imsim-uk/wp-content/uploads/sites/8/2025/02/Accessories_Banner.png);
    background-repeat: no-repeat;
    height: 1000px;
    background-position: center;
    background-size: cover;
}
.contactArea {
    background-color: #FD021D;
}
.contactTitle {
    color: #000000;
    font-size: 40px;
    font-weight: bold;
    text-align: left;
    margin-top: 200px;
    padding-bottom: 30px;
}
p.contactText {
    color: #fff;
    font-size: 25px;
    font-weight: bold;
    text-align: left;
    margin-bottom: 200px;
}
.mainHeader {
    color: #FD021D;
    font-size: 60px;
    font-weight: bold;
    text-align: left;
    margin-top: 150px;
}
.subHeader {
    color: #FFFFFF;
    font-size: 50px;
    font-weight: bold;
    text-align: left;
    margin-top: 30px;
}
.mainText {
    font-size: 18px;
    font-weight: bold;
    text-align: left;
    margin-top: 50px;
}
.linksBelow {
    margin-top: 50px;
}
button.accessBTN {
    width: 100%;
    height: 65px;
    background-color: #FD021D;
    border: none;
    color: #fff;
    font-weight: bold;
}
button.accessBTN:hover {
    width: 100%;
    height: 65px;
    background-color: #fff;
    border: none;
    color: #000;
    font-weight: bold;
}
.youtube {
    width: 100px;
    position: absolute;
    top: -15px;
    right: -50px;
}
@media only screen and (max-width: 725px) {
    .mainHeader {
        font-size: 50px;
        margin-top: 50px;
    }
    .subHeader {
        font-size: 40px;
        margin-top: 30px;
    }
    .youtube {
        display: none;
    }
    button.accessBTN {
        width: 100%;
        height: 65px;
        background-color: #FD021D;
        border: none;
        color: #fff;
        font-weight: bold;
        margin-bottom: 20px;
    }
    .inner_accessories {
        background-image: url(https://wp-ocssport.ocs-sport.com/imsim-uk/wp-content/uploads/sites/8/2025/02/Accessories_Banner.png);
        background-repeat: no-repeat;
        height: 850px;
        background-position: center;
        background-size: cover;
    }
    .contactTitle {
        color: #000000;
        font-size: 35px;
        font-weight: bold;
        text-align: left;
        margin-top: 80px;
        padding-bottom: 30px;
    }
    p.contactText {
        color: #fff;
        font-size: 20px;
        font-weight: bold;
        text-align: left;
        margin-bottom: 20px;
    }
}
@media only screen and (max-width: 380px) {

}
</style>
